import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/core/services/common.service';
import { PubSubService } from '@app/core/services/pub-sub-service/pub-sub.service';
import { LoggerService } from '@app/core/services/logger.service';
import { MatDialog } from '@angular/material/dialog';
import { MediaRecorderComponent } from '../../../../users/components/media-recorder/media-recorder.component';
const SIDE_BAR_STATE = 'sidebarState'

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar-component.component.html',
  styleUrls: ['./side-bar-component.component.scss']
})
export class SideBarComponentComponent implements OnInit {
  userInfo: any;
  showhide: boolean = false;

  constructor(public dialog: MatDialog,
    private commonService: CommonService,
    private readonly pubSubService: PubSubService,
    private readonly logger: LoggerService) {
  }

  initSideBarState() {
    const sidebarState = this.sideBarState;
    this.showhide = sidebarState ? true : false;
    this.updateSideBarState();
  }

  get sideBarState() {
    try {
      const state = this.commonService.getLocalStorage(SIDE_BAR_STATE);
      return state === 'true';
    } catch (error) {
      return false;
    }

    //return window[SIDE_BAR_STATE];
  }

  set sideBarState(val: boolean) {
    this.commonService.setLocalStorage(SIDE_BAR_STATE, val);
    //window[SIDE_BAR_STATE] = val;
  }


  menutoggle() {
    this.showhide = !this.showhide;
    this.updateSideBarState();
  }

  updateSideBarState() {
    const matDrawer = document.querySelector("mat-drawer-container"), closeClass = "close";
    this.showhide ? matDrawer.classList.add(closeClass) : matDrawer.classList.remove(closeClass);
    this.pubSubService.sendMenuUpdateEvent(this.showhide);
    this.sideBarState = this.showhide;
  }

  async ngOnInit() {
    this.userInfo = await this.commonService.getuserInfo();
    this.profileUpdater();
    this.initSideBarState();
  }

  /**
   * update profile when change in account profile
   */
  profileUpdater() {
    this.pubSubService.profileUpdater.subscribe(async (res: any) => {
      this.userInfo = await this.commonService.getuserInfo();
    }, (err: any) => {
      this.logger.error(err);
    })
  }

  /**
   * logout 
   */
  logout() {
    this.commonService.logout();
  }

  /**
   * open media recorder instruction for safari browser
   */
  mediarecorder(): void {
    const dialogRef = this.dialog.open(MediaRecorderComponent, {
      width: '1300px',
    });
  }

}
